export const CATEGORIES = [
  {
    slug: "weight-loss",
    name: "Weight Loss Management",
    short: "Weight Loss",
    image:
      "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1600&q=80",
    intro:
      "Peptides studied for metabolic regulation, GLP-1 pathways, and appetite-related research. Sourced for purity, validated by independent labs.",
    science:
      "Modern weight-management research focuses on incretin biology — GLP-1 and GIP receptor signaling — and their downstream effects on insulin sensitivity, satiety, and adipose tissue metabolism. Our catalog supports investigators studying these pathways in pre-clinical models.",
  },
  {
    slug: "longevity",
    name: "Longevity",
    short: "Longevity",
    image:
      "https://images.unsplash.com/photo-1556228841-7db5b6786a34?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwxfHxsb25nZXZpdHklMjBoZWFsdGh5JTIwYWdpbmd8ZW58MHx8fHwxNzgxNDI4NTUxfDA&ixlib=rb-4.1.0&q=85",
    intro:
      "A curated selection of peptides and cofactors studied within cellular senescence, telomere biology, and mitochondrial function research.",
    science:
      "Longevity science investigates the molecular hallmarks of aging — telomere attrition, mitochondrial dysfunction, and chronic inflammation. The compounds in this category have published research footprints in academic and translational labs worldwide.",
  },
  {
    slug: "recovery",
    name: "Recovery",
    short: "Recovery",
    image:
      "https://images.unsplash.com/photo-1579758629938-03607ccdbaba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxtdXNjbGUlMjByZWNvdmVyeSUyMHNwb3J0c3xlbnwwfHx8fDE3ODE0Mjg1NTF8MA&ixlib=rb-4.1.0&q=85",
    intro:
      "Peptides explored in tissue repair, anti-inflammatory pathways, and post-injury cellular biology research.",
    science:
      "Recovery research targets pathways involved in angiogenesis, fibroblast activity, and collagen synthesis — central to wound healing, musculoskeletal repair, and gastrointestinal mucosal protection.",
  },
  {
    slug: "performance",
    name: "Performance",
    short: "Performance",
    image:
      "https://images.unsplash.com/photo-1526506118085-60ce8714f8c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxmaXRuZXNzJTIwcGVyZm9ybWFuY2UlMjBhdGhsZXRlfGVufDB8fHx8MTc4MTQyODU1MXww&ixlib=rb-4.1.0&q=85",
    intro:
      "Investigational peptides supporting research into endocrine performance, growth hormone secretion, and lean tissue biology.",
    science:
      "Performance research often centers on the GHRH/ghrelin axis and its pulsatile regulation of endogenous growth hormone. Compounds here are widely cited in pre-clinical literature.",
  },
];

export const categoryBySlug = (slug) => CATEGORIES.find((c) => c.slug === slug);
